import { InformationCircleIcon } from "@heroicons/react/outline";
import { FC, ReactNode } from "react";
import { memo } from "react";
import { cn } from "@gettactic/helpers";
import { Popover, PopoverContent, PopoverTrigger } from "@cmp-src/primitives";

interface Props {
  /** Width of the popover, in px. Default 300. */
  width?: number;
  /** Size of the icon. Default "md". */
  size?: "sm" | "md" | "lg";
  /** Side of the icon the popover opens on. Default "bottom". */
  position?: "top" | "right" | "bottom" | "left";
  testId?: string;
  /** Accessible name of the icon button and its popover. Default "More information". */
  label?: string;
  /** The explanation. */
  children: ReactNode;
}

/** An "i" button that opens an explanation in a popover on click. */

export const InfoTooltip: FC<Props> = memo(
  ({
    width = 300,
    size = "md",
    position = "bottom",
    testId,
    label = "More information",
    children
  }) => {
    return (
      <Popover>
        <PopoverTrigger aria-label={label}>
          <InformationCircleIcon
            aria-hidden="true"
            className={cn(
              "info-tooltip ml-2 inline cursor-pointer text-neutral-700",
              {
                "h-4 w-4": size === "sm",
                "h-5 w-5": size === "md",
                "h-7 w-7": size === "lg"
              }
            )}
            data-testid={testId}
          />
        </PopoverTrigger>
        <PopoverContent
          side={position}
          style={{ width }}
          showArrow
          aria-label={label}
        >
          {children}
        </PopoverContent>
      </Popover>
    );
  }
);
